import React from 'react';
import FullScreenGamePlayer from '../domains/games/components/FullScreenGamePlayer';

const FullScreenGamePage: React.FC = () => {
  return <FullScreenGamePlayer />;
};

export default FullScreenGamePage;




